/**
 * Slow-boot diagnostic threshold (legacy).
 * Auto full-screen diagnostic is OFF by default — it replaced the loading UI after
 * this delay and felt like a system block (only "copy report" / "reload app").
 * Enable only for debugging: REACT_APP_LOADING_DIAGNOSTIC=1 or
 * window.__AMAN_LOADING_DIAGNOSTIC__ = true
 */
export const LOADING_DIAGNOSTIC_MS = 18000;

/** @returns {boolean} */
export function isLoadingDiagnosticAutoShowEnabled() {
  if (
    typeof window !== 'undefined' &&
    window.__AMAN_LOADING_DIAGNOSTIC__ === true
  ) {
    return true;
  }
  return (
    process.env.REACT_APP_LOADING_DIAGNOSTIC === '1' ||
    process.env.REACT_APP_LOADING_DIAGNOSTIC === 'true'
  );
}
